<!--
 * @Description：公用头部组件
 * @author： mh
 * @date： 2024/12/09 14:10:00
!-->
<template>
  <div class="web_header">
    <!-- 登录页头部 -->
    <div class="login_header container" v-if="$route.path == '/login'">
      <div class="web_title_box flex pointer" @click="logoClick">
        <img src="../assets/imgs/logo.svg" alt="" />
      </div>
    </div>
    <!-- 态势地图的头部 -->
    <div v-else-if="['/postureMap'].includes(currentPath)" class="posture_header flex align_items_ctr">
      <div class="flex_1"></div>
      <div class="flex align_items_start">
        <div class="ph_navs flex align_items_ctr" v-if="showCatBar">
          <div :class="[
            'nav fw pointer',
            currentIndex === item.id ? 'active_nav' : '',
          ]" v-for="(item, index) in navList" :key="index" @click="navClick(item, index)">
            <div class="nav_label">{{ item.label }}</div>
            <div class="nav_ph_prop" v-if="item.children">
              <div v-for="(c, i) in item.children" :key="i" @click.stop="navSeconClick(c, c.id, item.id)">
                <div class="np_label" :class="{ actLabel: currentSeconId === c.id }">
                  {{ c.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <img class="btn-opt cur" @click="operationClick('menuBtn')"
          :src="require(`@/assets/imgs/graph/menu_btn_active.png`)" />
        <el-tooltip placement="bottom-end" effect="light">
          <img class="btn-opt" :src="require(`@/assets/imgs/graph/user_btn_active.png`)" />
          <div slot="content" class="operation_content text_ctr" style="line-height: 2;width: 50px;">
            <div class="center pointer_fw" v-if="showUserName != '游客' && userType == 1"
              @click="$router.push('/personalCenter')">
              个人中心
            </div>
            <div class="login pointer_fw" @click="goLoginClick">
              {{ showUserName == "游客" ? "登录" : "注销" }}
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <!-- 其他页面的头部 -->
    <div v-else class="other_header">
      <div class="my_header" :style="headerStyle" :class="{
        nobg_header: ['/', '/industryAnalysis'].includes(currentPath),
        line_header: ['/graph'].includes(currentPath),
      }">
        <div :class="[
          ['/industryAnalysis'].includes(currentPath)
            ? 'ind_menu_width'
            : 'container',
        ]">
          <div class="bottom flex jc_sb align_items_ctr">
            <div class="web_title_box flex pointer" @click="logoClick" v-if="!['/'].includes(currentPath)">
              <img src="@/assets/imgs/logo.svg" alt="" />
            </div>
            <div class="flex_1 flex align_items_ctr jc_end">
              <div class="b_right flex">
                <div :class="[
                  'nav_list  pointer',
                  currentIndex === item.id ? 'activeNav fw' : '',
                ]" v-for="(item, index) in navList" :key="index" @click.stop="navClick(item, index)">
                  <div class="inner_label">{{ item.label }}</div>
                  <div class="nav_other_prop" v-if="item.children">
                    <div v-for="(c, i) in item.children" :key="i" @click.stop="navSeconClick(c, c.id, item.id)">
                      <div class="np_label" :class="{ actLabel: currentSeconId === c.id }">
                        {{ c.label }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-tooltip placement="bottom-end" effect="light">
                <img src="../assets/imgs/header/user.svg" class="cur" style="margin-left: 40px" />
                <div slot="content" class="operation_content text_ctr" style="line-height: 2;width: 50px;">
                  <div class="center pointer_fw" v-if="showUserName != '游客' && userType == 1"
                    @click="$router.push('/personalCenter')">
                    个人中心
                  </div>
                  <div class="login pointer_fw" @click="goLoginClick">
                    {{ showUserName == "游客" ? "登录" : "注销" }}
                  </div>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="simple_search">
            <div class="search_outer_box" v-if="showSearchBox">
              <div class="container flex jc_ctr">
                <div class="search_box">
                  <div class="flex jc_sb align_items_ctr">
                    <div class="search_input">
                      <el-input placeholder="请输入检索关键词..." v-model="searchKey" class="input-with-select"
                        @keyup.enter.native="searchClick" @clear="searchClick" clearable>
                        <el-select v-model="selectValue" slot="prepend" placeholder="请选择" @change="selectChange"
                          transfer :popper-append-to-body="true">
                          <el-option :label="item.label" :value="item.value" v-for="(item, index) in searchFieldsOptons"
                            :key="index"></el-option>
                        </el-select>
                        <div slot="append">
                          <div class="search_icon_box flex jc_ctr align_items_ctr pointer" @click="searchClick">
                            <img src="../assets/imgs/header/search_icon.svg" />
                          </div>
                        </div>
                      </el-input>
                    </div>
                    <div class="operType_box flex flex_col jc_sa" v-if="currentPath != '/'">
                      <div :class="[
                        'operType flex align_items_ctr cur',
                        item.value == currentOp ? 'active_oper' : '',
                      ]" v-for="(item, index) in operTypeOptions" :key="index" @click="operTypeClick(item)">
                        <img :src="require(`../assets/imgs/header/${item.value == currentOp ? 'checked' : 'no_check'
                          }.svg`)
                          " alt="" />
                        {{ item.label }}
                      </div>
                    </div>
                    <div class="adv my_card pointer" @click="advBtnClick">
                      高级检索
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bread v-if="true && showBread" />
  </div>
</template>

<script>
import bread from "../components/Breadcrumb/index.vue";
import { mapState } from "vuex";
import { logoutApi } from "@/apis/api";
export default {
  name: "WorkspaceJsonHeader",
  inject: ["reload"],
  components: {
    bread,
  },
  data() {
    return {
      // 主导航栏
      currentIndex: "sy",
      currentSeconId: "",
      navList: [
        { label: "首页", path: "/", id: "sy" },
        { label: "情报动态", path: "/qbDynamic", id: "qbdt" },
        {
          label: "军研文献",
          path: "/list?moduleCode=RDPI_search_jywx",
          id: "jywx",
        },
        { label: "专题研究", path: "/monographicStudy", id: "ztyj" },
        {
          label: "分析工具",
          path: "/graph",
          id: "fxgj",
          children: [
            { label: "军情图谱", path: "/graph", id: "jqtp" },
            { label: "态势地图", path: "/postureMap", id: "tsdt" },
            { label: "武器对比", path: "/equipComparison", id: "wqdb" },
            { label: "装备问答", path: "/equipQA", id: "zbdb" },
          ],
        },
        {
          label: "数据中心",
          path: "/dataCenter",
          id: "sjzx",
          children: [
            { label: "资源导航", path: "/resGuidance", id: "zydh" },
            { label: "数据分析", path: "/industryAnalysis", id: "sjfx" },
            { label: "俄军体系", path: "/dcArchitecture", id: "ejtx" },
            { label: "乌军体系", path: "/dcArchitecture2", id: "wjtx" },
          ],
        },
      ],
      searchKey: "", //检索词
      // 下拉数据
      selectValue: "RDPI_search_all",
      searchFieldsOptons: [
        { label: "全部", path: "/list", value: "RDPI_search_all" },
        { label: "情报动态", path: "/list", value: "RDPI_search_qb_dynamics" },
        { label: "军研文献", path: "/list", value: "RDPI_search_jywx" },
        { label: "战争战例", path: "/list", value: "RDPI_search_battle_case" },
        { label: "军政人事", path: "/list", value: "RDPI_search_person" },
        { label: "武器装备", path: "/list", value: "RDPI_search_weapon" },
        { label: "组织单位", path: "/list", value: "RDPI_search_org" },
        {
          label: "视频影像",
          path: "/list",
          value: "RDPI_search_media&mediaType=2",
        },
        {
          label: "图片资料",
          path: "/list",
          value: "RDPI_search_media&mediaType=1",
        },
      ],
      dates: {
        start: "",
        end: "",
      },
      showCatBar: true,
      currentOp: 'MATCH',
      operTypeOptions: [
        { label: "精确", value: "MATCH_PHRASE" },
        { label: "模糊", value: "MATCH" },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    // 用户权限信息
    userMapInfo() {
      const { map } = this.userInfo || {}
      return map ? JSON.parse(map) : {}
    },
    userType() {
      return this.userMapInfo?.userType
    },
    showUserName() {
      const { subUserInfo, realName, unit, userName } = this.userInfo;
      if (subUserInfo) {
        const { realName: subRealName } = subUserInfo;
        return subRealName;
      }
      return realName || unit || userName;
    },
    showSearchBox() {
      let path = this.$route.path;
      return (
        ["/personalCenter", "/", "/industryAnalysis", "/graph"].includes(
          path
        ) == false
      );
    },
    showDatesBox() {
      let path = this.$route.path;
      return ["/report", "/project"].includes(path);
    },

    showCat() {
      return ["/", "/qbDynamic"].includes(this.currentPath);
    },
    showBread() {
      let path = this.$route.path;
      return (
        ["/", "/graph", "/postureMap", "/login", "/industryAnalysis"].includes(
          path
        ) == false
      );
    },
    currentPath() {
      return this.$route.path;
    },
    headerStyle() {
      // 除了高级检索外按路由来判断大小
      let heightMap = {
        "/": "90px",
        "/industryAnalysis": "90px",
        "/qbDynamic": "290px",
        "/personalCenter": "140px",
        "/graph": "100px",
      };
      return {
        height: heightMap[this.currentPath] || "290px",
      };
    },
  },
  mounted() {
    this.$parent.getHeaderHeight();
    const { moduleCode } = this.$route.query;
    console.log(moduleCode, "moduleCodemoduleCodemoduleCode");
  },
  updated() {
    this.$parent.getHeaderHeight();
  },
  methods: {
    // 点击--一级菜单
    navClick(item, index) {
      this.currentIndex = item.id;
      this.currentSeconId = "";
      console.log(this.userMapInfo, 'userMapInfouserMapInfo');
      /* 
        若不是军研文献直接放行
        若是军研文献必须listRight==1才放行
      */
      if (item.id != 'jywx' || this.userMapInfo?.listRight == 1) {
        if (this.$route.path == item.path) {
          this.reload();
        } else {
          // 如果有二级菜单，点击一级默认，选中第一个
          if (item.children) {
            this.currentSeconId = item.children[0].id;
          }
          this.$router.push(item.path);
        }
      } else {
        this.$message({
          message: '无页面访问权限',
          type: 'warning',
          customClass: 'messageIndex'
        })
      }

    },
    // 点击-- 二级菜单
    navSeconClick(curItem, curId, oneId) {
      this.currentIndex = oneId;
      this.currentSeconId = curId;
      if (this.$route.path == curItem.path) {
        this.reload();
      } else {
        this.$router.push(curItem.path);
      }
    },
    selectChange() {
      // this.$router.push(this.selectValue);
    },
    searchClick() {
      this.$store.commit("advAndTagArr", []);
      this.$store.commit("advInputTagArr", []);
      this.$store.commit("saveAreaObj", {});
      let clickObj = this.searchFieldsOptons.find((option) => {
        return option.value == this.selectValue;
      });
      if (clickObj) {
        this.$router.push(
          clickObj.path +
          "?moduleCode=" +
          clickObj.value +
          "&searchKey=" +
          this.searchKey +
          '&operateType=' +
          this.currentOp
        );
        this.searchKey = ''
      }
      if (this.currentPath == "/list") {
        this.reload();
      }
    },
    async goLoginClick() {
      console.log(this.showUserName);
      if (this.showUserName == "游客") {
        this.$router.push("/login");
      } else {
        let res = await logoutApi({
          token: sessionStorage.getItem("token") || "",
        });
        this.$message[res.success ? "success" : "error"](
          res.data || res.message
        );
        if (res.success) {
          sessionStorage.removeItem("token");
          this.$router.push("/login");
        }
      }
    },

    logoClick() {
      this.$router.push("/");
    },
    catClick(item) {
      this.$router.push(item.path);
    },
    advBtnClick() {
      this.$router.push("/advSearch");
    },

    /*态势地图--- 右侧按钮点击 */
    operationClick(type) {
      if (type == "menuBtn") {
        this.showCatBar = !this.showCatBar;
      }
    },
    operTypeClick(item) {
      this.currentOp = item.value
    },
  },
  watch: {
    $route(n, o) {
      /* 路由变化，且无路由传参时清空输入值 */
      const { searchKey, dates, moduleCode, mediaType } = n.query;
      if (!searchKey && !dates) {
        this.searchKey = "";
        this.dates.start = "";
        this.dates.end = "";
      } else {
        /* 手动刷新的时候重新赋值 */
        if (searchKey) {
          // this.searchKey = searchKey;
        }
        if (dates) {
          let d = JSON.parse(dates);
          const { start, end } = d;
          this.dates.start = start;
          this.dates.end = end;
        }
      }
      /* 设置主输入框选中状态 */
      let index = this.searchFieldsOptons.findIndex((option) => {
        return option.value == moduleCode + (mediaType ? `&mediaType=${mediaType}` : '');
      });
      this.selectValue = this.searchFieldsOptons[index > -1 ? index : 0].value;
    },
  },
};
</script>
<style lang="less" scoped>
.web_header {
  position: relative;
  z-index: 99;
}

// 数据分析菜单行宽度
.ind_menu_width {
  margin: 0 120px;
}

// 其他--下拉菜单样式
.nav_other_prop {
  display: none;
  width: 100%;
  position: absolute;
  background: linear-gradient(180deg, rgba(5, 23, 37, 0) 0%, #0c2033 100%);
  border-radius: 0px 0px 8px 8px;
  border: 1px solid;
  border-image: linear-gradient(180deg,
      rgba(60, 66, 84, 0),
      rgba(60, 66, 84, 1)) 1 1;

  .np_label {
    margin-top: 8px;
    word-break: keep-all;
    font-size: 16px;
    line-height: 30px;
    color: #cfe0e5;
    font-family: HuXiaoBo-NanShen, HuXiaoBo-NanShen;
    font-weight: 400;

    &:hover {
      color: #7ecce5;
    }
  }

  .actLabel {
    color: #7ecce5;
    font-weight: bold;
  }
}

// 态势地图--下拉菜单样式
.nav_ph_prop {
  display: none;
  width: 100%;
  position: absolute;
  padding: 4px 5px 12px 5px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  background: url("~@/assets/imgs/down_menu_bg.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 2px;
  color: #061a29;
  border-top: 4px solid transparent;

  .np_label {
    text-align: center;
    margin-top: 8px;
    word-break: keep-all;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #f5f5f6;
    line-height: 20px;

    &:hover {
      color: #7ecce5;
    }
  }

  .actLabel {
    color: #7ecce5;
    font-weight: bold;
  }
}

.nobg_header {
  width: 100%;
  position: absolute;
  background: transparent !important;
}

.line_header {
  background: transparent !important;
  border-bottom: 1px solid rgba(185, 232, 255, 0.2);
}

.my_header {
  color: #1d2541;
  line-height: 1;
  padding-bottom: 20px;
  background: url("../assets/imgs/header/header_bg.png") no-repeat;
  background-size: 100% 100%;
  height: 288px;
  padding-top: 32px;

  .bottom {
    height: 58px;

    .b_right {
      font-size: 17px;

      .nav_list {
        line-height: 33px;
        text-align: center;
        margin-left: 36px;
        font-size: 18px;
        font-family: HuXiaoBo-NanShen, HuXiaoBo-NanShen;
        font-weight: 400;
        color: #cfe0e5;
        position: relative;

        .inner_label {
          padding: 0 12px;
        }

        &:hover {
          .nav_other_prop {
            display: block;
          }
        }
      }

      .activeNav {
        color: #7ecce5;
      }
    }

    .login_btn {
      font-size: 14px;
      color: #1d4a77;
      line-height: 33px;
      padding-bottom: 6px;

      >img {
        margin-left: 8px;
      }
    }
  }
}

.search_outer_box {
  padding: 75px 0 40px 0;

  .search_box {
    .search_navs {
      padding-bottom: 24px;

      .search_nav {
        margin-right: 40px;
        color: #1d4a77;
        font-size: 16px;
        display: flex;
        align-items: flex-end;
      }

      .active_s_nav {
        color: #1d2541;
        font-size: 20px;
      }
    }

    .search_input {
      width: 880px;
      box-shadow: 0px 0px 8px 0px rgba(132, 132, 132, 0.1);
    }

    .operType_box {
      height: 60px;
      margin-left: 16px;

      .operType {
        color: #fff;

        >img {
          margin-right: 10px;
        }
      }

      .active_oper {
        font-weight: bold;
      }
    }

    .adv {
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: #ffffff;
      border-radius: 6px;
      font-size: 15px;
      color: #28283e;
      margin-left: 16px;
      padding: 0 20px;
    }

    .search_icon_box {
      width: 80px;
      height: 60px;
    }

    /deep/.el-select {
      position: relative;
    }

    /deep/.el-select .el-input__inner {
      width: 157px;
      background-color: #fff;
      border: 0;
      border-radius: 8px 0 0 8px;
    }

    /deep/.el-select .el-input .el-select__caret {
      font-size: 18px;
      font-weight: bold;
    }

    /deep/.el-input-group__prepend {
      border: 0;
    }

    /deep/.el-input-group__append {
      background: #3055b4;
      border: 0;
      border-radius: 0 8px 8px 0;
      padding: 0;
    }

    /deep/.el-input__inner {
      border: 0;
      height: 60px;
      font-size: 16px;
      color: #28283e;
    }
  }
}

.web_title_box {
  color: #fff;

  >img {
    margin-right: 16px;
  }

  .web_title {
    .zh {
      font-size: 32px;
      font-weight: bold;
    }

    .en {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 4px;
    }
  }
}

.login_header {
  padding-top: 80px;
}

.posture_header {
  padding: 58px 120px 0 0;

  .ph_navs {
    background: linear-gradient(90deg, rgba(0, 23, 34, 0.8) 0%, #001722 100%);
    border-top: 1px solid rgba(126, 204, 229, 0.5);
    padding: 12px 20px 0px 20px;
    position: relative;

    &::before {
      display: block;
      content: "";
      position: absolute;
      right: -10px;
      top: 5px;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid #001722;
      border-right: 6px solid transparent;
    }

    .nav {
      font-weight: 400;
      font-size: 15px;
      color: #f5f5f6;
      margin-right: 16px;
      font-weight: 400;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        .nav_ph_prop {
          display: block;
        }
      }

      .nav_label {
        padding: 0 12px 12px 12px;
      }
    }

    .active_nav {
      color: #7ecce5;
      font-weight: bold;
    }
  }

  .btn-opt {
    margin-left: 16px;
    margin-bottom: 8px;
  }
}
</style>